export class ServiceCardIcon {
  constructor(element) {
    this._image = element.querySelector('img');
    this._placeholder = element.querySelector('[data-service-card-icon-placeholder]');

    if (!this._image || !this._placeholder) return;

    this._image.addEventListener('error', () => this._showPlaceholder(), { once: true });

    if (this._image.complete && this._image.naturalWidth === 0) {
      this._showPlaceholder();
    }
  }

  _showPlaceholder() {
    this._image.hidden = true;
    this._placeholder.hidden = false;
  }
}
